export default __webpack_public_path__ + "assets/images/9120d542e68a3627666794c1e08033bd.png";